import Lights from 'shared/components/lights';

export default class ReportButton {
  constructor({ $element: $element }) {
    this.$element = $element;
    this.lights = Lights;

    this.selector = {
      reportForm: "#report-abuse-" + $element[0].dataset.reportId,
      reportSubmit: ".report-abuse__submit",
      embedVideo: ".embed-video--container"
    };

    this.ui = {};

    Object.keys(this.selector).forEach((key) => {
      this.ui[key] = $(this.selector[key]);
    });
  }

  init() {
    this.$element.on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.showForm();
    }.bind(this));

    this.ui.reportSubmit.on('click', function() {
      this.hideForm();
    }.bind(this));
  }

  hideForm() {
    document.getElementsByTagName("body")[0].style.removeProperty("overflow");
    this.ui.reportForm.hide();
    this.lights.on.bind(this)();
    this.showNavbar(this.navbarSelector());
  }

  showForm() {
    document.getElementsByTagName("body")[0].style.overflow = 'hidden';
    this.ui.reportForm.show();
    this.lights.off.bind(this)();
    this.hideNavbar(this.navbarSelector());
  }

  close() {
    this.hideForm();
  }

  navbarSelector() {
    return $('header#navbar');
  }

  hideNavbar($element) {
    $element.addClass('hide-navbar');
  }

  showNavbar($element) {
    $element.removeClass('hide-navbar');
  }
}
